import { useTranslation } from 'react-i18next';
import EmptyState from 'components/EmptyState';
import { cn } from 'lib/utils';
import type { ImportAddition } from 'api/technicianImportContract';
import { tableHead, tableRow } from './importTable';

const COLUMNS = 'grid-cols-[70px_180px_1fr_140px_160px]';

const ImportAdditionsPanel = ({ additions }: { additions: ImportAddition[] }) => {
  const { t } = useTranslation();
  if (additions.length === 0) return <EmptyState title={t('No addition in this file')} />;
  return (
    <div className="overflow-clip rounded-xl border">
      <div className={cn(tableHead, 'sticky top-0', COLUMNS)}>
        <span>{t('Row')}</span><span>{t('Technician')}</span><span>{t('Email')}</span><span>{t('Company')}</span><span>{t('Primary areas')}</span>
      </div>
      {additions.map((addition) => (
        <div key={addition.row} className={cn(tableRow, COLUMNS)}>
          <span className="text-muted-foreground">{addition.row}</span>
          <span className="font-medium">{addition.name}</span>
          <span className="truncate text-muted-foreground">{addition.email}</span>
          <span>{addition.company || '—'}</span>
          <span>{addition.zonesPrimary.join(', ') || '—'}</span>
        </div>
      ))}
    </div>
  );
};

export default ImportAdditionsPanel;
